export default function Hero() {
  return (
    <section className="py-8 md:py-12 pb-6 md:pb-8" id="top">
      <div className="font-mono text-xs tracking-wide uppercase text-accent-dark mb-2">
        created by <a href="/author" className="hover:underline">Ryan Deeds</a>
      </div>
      <h1 className="m-0 text-[clamp(28px,8vw,64px)] leading-[1.1] md:leading-[1.02] tracking-[-0.02em] font-semibold">
        Strategy is intent.<br />
        Action is the test.<br />
        This is the record of those tests.
      </h1>
      <p className="max-w-[62ch] mt-4.5 text-base leading-[1.7] text-muted-dark">
        This is a place to experiment. Open any experiment below to see the intent, the action taken, and what happened next.
      </p>
    </section>
  )
}

